// extracted by mini-css-extract-plugin
export default {"menuRow":"PmpyIq4G2zqwyv79WhXq","ctaLinkButton":"Uxwf2mgdtOGXJWYDmNYq"};